import React from "react";
import { ConnectedRouter } from "connected-react-router";
import { history } from "./store/store";
import ConnectedIntlProvider from "./ConnectedIntlProvider";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import { store, persistor } from "./store/store";

function AppProviders(props) {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <ConnectedIntlProvider>{props.children}</ConnectedIntlProvider>
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  );
}

export { AppProviders as Providers };
